import React, { useState } from 'react';
import { submitNetlifyForm } from '../../utils/netlifyForm';
import { useLang } from '../../i18n/LanguageContext';

const inputCls = 'mt-1.5 w-full rounded-xl border border-slate-200 px-4 py-3 focus:outline-none focus:ring-2 focus:ring-brand';

// Field names must match the "contact" form in public/__forms.html (Netlify Forms).
function ContactForm() {
  const { t } = useLang();
  const [isSending, setIsSending] = useState(false);
  const [isSent, setIsSent] = useState(false);
  const [error, setError] = useState(null);

  const send = (e) => {
    e.preventDefault();
    setIsSending(true);
    setError(null);
    const form = e.target;
    submitNetlifyForm('contact', form)
      .then(() => { setIsSending(false); form.reset(); setIsSent(true); },
        () => { setIsSending(false); setError(t('cfError')); });
  };

  if (isSent) {
    return (
      <div className="p-8 bg-emerald-50 border border-emerald-200 rounded-3xl text-center" role="status">
        <div className="text-4xl" aria-hidden="true">✅</div>
        <h3 className="mt-2 text-xl font-extrabold text-emerald-800">{t('cfSentTitle')}</h3>
        <p className="text-emerald-700 mt-2">{t('cfSentText')}</p>
        <button type="button" onClick={() => setIsSent(false)} className="mt-4 text-sm font-semibold text-emerald-800 underline">{t('cfAnother')}</button>
      </div>
    );
  }

  return (
    <form name="contact" onSubmit={send} className="space-y-4">
      {/* Spam trap: people never see or fill this; Netlify drops any submission that has it filled */}
      <input type="text" name="bot-field" tabIndex="-1" autoComplete="off" className="hidden" aria-hidden="true" />
      <div className="grid sm:grid-cols-2 gap-4">
        <label className="block text-sm font-semibold">{t('fName2')}<input type="text" name="user_name" required autoComplete="name" className={inputCls} /></label>
        <label className="block text-sm font-semibold">{t('fMobile')}
          <input type="tel" name="user_mobile" required inputMode="numeric" pattern="[0-9]{10}" title={t('cfMobileHint')} placeholder="98xxxxxxxx" autoComplete="tel-national" className={inputCls} /></label>
      </div>
      <label className="block text-sm font-semibold">{t('fMail')}<input type="email" name="user_email" autoComplete="email" className={inputCls} /></label>
      <label className="block text-sm font-semibold">{t('fMsg')}<textarea name="message" rows="4" required className={inputCls} /></label>
      <button type="submit" disabled={isSending} className="w-full bg-saffron hover:bg-orange-600 disabled:bg-slate-400 text-white font-bold py-3.5 rounded-xl transition">
        {isSending ? t('sending') : t('fSend')}
      </button>
      {error && <p className="p-3 bg-rose-50 border border-rose-200 rounded-xl text-sm text-rose-700 text-center" role="alert">{error}</p>}
    </form>
  );
}

export default ContactForm;
